<div class="Footer_bottom">
  <section class="first-section page-hero-section d-flex flex-column align-items-center justify-content-center" [ngStyle]="(aboutUS && aboutUS[0] && aboutUS[0].banner) ? {'background-image': 'url(' + aboutUS[0].banner + ')'} : {}">
    <div class="container-fluid">
      <div class="row justify-content-center align-items-center">
        <div class="col-md-6">
    <h1 class="page-hero-title text-center">{{ (aboutUS && aboutUS[0] && aboutUS[0].title) || 'About PRISM' }}</h1>
        </div>
      </div>
    </div>
  </section>

  <section class="para-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8" *ngIf="aboutUS && aboutUS.length">
                <div class="cms-content" [innerHTML]="aboutUS[0].subTitle | sanitizeHtml"></div>

            </div>
        </div>
    </div>
  </section>
</div>